import * as bio from './bio.json';
import * as contact from './contact.json';
import * as credentials from './credentials.json';
import * as landing from './landing.json';
import * as offerings from './offerings.json';
import * as portfolio from './portfolio.json';

export const en = {
  bio,
  contact,
  credentials,
  landing,
  offerings,
  portfolio,
};
